import React from "react";
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import {
	getWinClassName,
	betGroupProp,
} from "@/modules/commonMobile";

import { IGameTableType } from "@/types/GlobalTypes";
import { checkPlayerBankerTie, IBaccaratWinType } from "@/modules/games/Baccarat";

export interface IProps extends Omit<IGameTableType, "win"> {
	win: IBaccaratWinType;
	basePcode: string;
			
	pairs: {player: boolean, banker: boolean, either: boolean, perfect: boolean};
	checkTieWin: boolean;
	tieBetTypes: string[];
	totalCards: number;
}

export default class M22MultiTable extends React.Component<IProps> {
	render() {
		const gwcn = getWinClassName;
		
		const { basePcode, win, checkTieWin, tieBetTypes, totalCards, pairs, langdata } = this.props;
	
		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		};

		const commonTooltipProps = {
			langStr: langdata.language_code
		};

		// DESKTOP MULTI TABLE
		return (
			//IDN 4 STAND MULTI TABLE
			basePcode === "m28" ? (
				<div className={"sl-table m28"}>
					<div className="top">
						<div className={"sl-bet sl-baccarat-blue" + gwcn(win && pairs.player)}
							{...betGroupProp(this, "playerpair", "playerpair")}
							// bet="playerpair" pcode={this.props.pcode} group="playerpair"
							onClick={this.props.insertBet}>
							<span>{ this.props.langdata["txt_player_pair"] }</span>
		
							<div className="bet-type">11:1</div>
							<Chips {...commonChipProps} betKey={`playerpair+playerpair`} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[`playerpair+playerpair`]} />
						</div>

						<div className={"sl-bet sl-baccarat-red" + gwcn(win && pairs.banker)}
							{...betGroupProp(this, "bankerpair", "bankerpair")}
							// bet="bankerpair" pcode={this.props.pcode} group="bankerpair"
							onClick={this.props.insertBet}>
							<span>{ this.props.langdata["txt_banker_pair"] }</span>
	
							<div className="bet-type">11:1</div>
							<Chips {...commonChipProps} betKey={`bankerpair+bankerpair`} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[`bankerpair+bankerpair`]} />
						</div>
					</div>

					<div className="bottom">
						<div className={"sl-bet sl-baccarat-blue" + gwcn(win && (win.playerValue > win.bankerValue))}
							// bet="player" pcode={this.props.pcode} group="player"
							{...betGroupProp(this, "player", "player")}
							onClick={this.props.insertBet}>
							<div>{ this.props.langdata["txt_player"] }</div>
	
							<div className="bet-type">0.97:1</div>
							<Chips {...commonChipProps} betKey={`player+player`} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[`player+player`]} />
						</div>
						
						<div className={"sl-bet narrow sl-green-old" + gwcn(win && checkTieWin)}
							// bet="tie" pcode={this.props.pcode} group="tie"
							{...betGroupProp(this, "tie", "tie")}
							onClick={this.props.insertBet}>
							<div>{ this.props.langdata["txt_tie"] }</div>
	
							<div className="bet-type">8:1</div>
							<Chips {...commonChipProps} betKey={`tie+tie`} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[`tie+tie`]} />
						</div>
						
						<div className={"sl-bet sl-baccarat-red" + gwcn(win && (win.playerValue < win.bankerValue))}
							// bet="banker" pcode={this.props.pcode} group="banker"
							{...betGroupProp(this, "banker", "banker")}
							onClick={this.props.insertBet}>
							<div>{ this.props.langdata["txt_banker"] }</div>
	
							<div className="bet-type">0.97:1</div>
							<Chips {...commonChipProps} betKey={`banker+banker`} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[`banker+banker`]} />
						</div>
					</div>
				</div>
			) : (
			// BACCARAT MULTI TABLE
				<div className={"sl-table m22"}>
					<div className="tie-label">
						{this.props.langdata["txt_tie_on"]}
					</div>
					<div className="top">
						<div className={"sl-bet sl-green-old" + gwcn(pairs.either)}
							// bet="eitherpair" pcode={this.props.pcode} group="eitherpair"
							{...betGroupProp(this, "eitherpair", "eitherpair")}

							onClick={this.props.insertBet}>
							<span>{ this.props.langdata["txt_either_pair"] }</span>
							<div className="bet-type">5:1</div>
							<Chips {...commonChipProps} betKey={`eitherpair+eitherpair`} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[`eitherpair+eitherpair`]} />
						</div>
						
						{
							[0, 1, 2, 3, 4].map((item, idx) => {
								const betKey = `tie${item}`;
								
								return <div key={item} className={"sl-bet sl-green-old" + gwcn(checkTieWin && win.playerValue === item)}
									// bet={betKey} pcode={this.props.pcode} group={betKey}
									{...betGroupProp(this, betKey, betKey)}
									onClick={this.props.insertBet}>
									<span>{ item }</span>
									<div className="bet-type">
										{ tieBetTypes[item] }
									</div>
									
									<Chips {...commonChipProps} betKey={`${betKey}+${betKey}`} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[`${betKey}+${betKey}`]} />
								</div>;
							})
						}
						
						<div className={"sl-bet sl-green-old" + gwcn(pairs.perfect)}
							// bet="perfectpair" pcode={this.props.pcode} group="perfectpair"
							{...betGroupProp(this, "perfectpair", "perfectpair")}
							onClick={this.props.insertBet}>
							<span>{ this.props.langdata["txt_perfect_pair"] }</span>
							<div className="bet-type">25:1</div>
							
							<Chips {...commonChipProps} betKey={`perfectpair+perfectpair`} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[`perfectpair+perfectpair`]} />
						</div>
					</div>
					
					<div className="middle">
						<div className={"sl-bet sl-green-old" + gwcn(win && totalCards === 4)}
							// bet="small" pcode={this.props.pcode} group="small"
							{...betGroupProp(this, "small", "small")}
							onClick={this.props.insertBet}>
							<span>{ this.props.langdata["txt_small"] }</span>
							
							<div className="bet-type">1.5:1</div>
							<Chips {...commonChipProps} betKey={`small+small`} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[`small+small`]} />
						</div>
						
						{
							[5, 6, 7, 8, 9].map((item, idx) => {
								const betKey = `tie${item}`;
								
								return <div key={item} className={"sl-bet sl-green-old" + gwcn(checkPlayerBankerTie(win, item))}
									// bet={betKey} pcode={this.props.pcode} group={betKey}
									{...betGroupProp(this, betKey, betKey)}
									onClick={this.props.insertBet}>
									<span>{ item }</span>
									<div className="bet-type">
										{ tieBetTypes[item] }
									</div>
									
									<Chips {...commonChipProps} betKey={`${betKey}+${betKey}`} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[`${betKey}+${betKey}`]} />
								</div>;
							})
						}
						
						<div className={"sl-bet sl-green-old" + gwcn(win && totalCards > 4)}
							// bet="big" pcode={this.props.pcode} group="big"
							{...betGroupProp(this, "big", "big")}
							onClick={this.props.insertBet}>
							<span>{ this.props.langdata["txt_big"] }</span>
						
							<div className="bet-type">0.54:1</div>
							<Chips {...commonChipProps} betKey={`big+big`} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[`big+big`]} />
						</div>
					</div>
					
					<div className="bottom">
						<div className="sides">
							<div className={"sl-bet sl-baccarat-blue" + gwcn(pairs.player)}
								// bet="playerpair" pcode={this.props.pcode} group="playerpair"
								{...betGroupProp(this, "playerpair", "playerpair")}
								onClick={this.props.insertBet}>
								<span>{ this.props.langdata["txt_player_pair"] }</span>
			
								<div className="bet-type">11:1</div>
								<Chips {...commonChipProps} betKey={`playerpair+playerpair`} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[`playerpair+playerpair`]} />
							</div>
						</div>
						
						<div className="middle">
							<div className={"sl-bet sl-baccarat-blue" + gwcn(win && (win.playerValue > win.bankerValue))}
								// bet="player" pcode={this.props.pcode} group="player"
								{...betGroupProp(this, "player", "player")}
								onClick={this.props.insertBet}>
								<div>{ this.props.langdata["txt_player"] }</div>
		
								<div className="bet-type">1:1</div>
								<Chips {...commonChipProps} betKey={`player+player`} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[`player+player`]} />
							</div>
							<div className={"sl-bet sl-green-old" + gwcn(checkTieWin)}
								// bet="tie" pcode={this.props.pcode} group="tie"
								{...betGroupProp(this, "tie", "tie")}
								onClick={this.props.insertBet}>
								<div>{ this.props.langdata["txt_tie"] }</div>
		
								<div className="bet-type">8:1</div>
								<Chips {...commonChipProps} betKey={`tie+tie`} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[`tie+tie`]} />
							</div>
							<div className={"sl-bet sl-baccarat-red" + gwcn(win && (win.playerValue < win.bankerValue))}
								// bet="banker" pcode={this.props.pcode} group="banker"
								{...betGroupProp(this, "banker", "banker")}
								onClick={this.props.insertBet}>
								<div>{ this.props.langdata["txt_banker"] }</div>
		
								<div className="bet-type">0.95:1</div>
								<Chips {...commonChipProps} betKey={`banker+banker`} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[`banker+banker`]} />
							</div>
						</div>
						
						<div className="sides">
							<div className={"sl-bet sl-baccarat-red" + gwcn(pairs.banker)}
								// bet="bankerpair" pcode={this.props.pcode} group="bankerpair"
								{...betGroupProp(this, "bankerpair", "bankerpair")}
								onClick={this.props.insertBet}>
								<span>{ this.props.langdata["txt_banker_pair"] }</span>
		
								<div className="bet-type">11:1</div>
								<Chips {...commonChipProps} betKey={`bankerpair+bankerpair`} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[`bankerpair+bankerpair`]} />
							</div>
						</div>
					</div>
				</div>
			)
		);
	}
}